export const ArrowPaginationLeft = (props: any) => (
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.8987 2.98424V1.92741C9.8987 1.8358 9.79343 1.78522 9.72233 1.84127L3.55905 6.65514C3.50669 6.69586 3.46431 6.74801 3.43517 6.8076C3.40602 6.86719 3.39087 6.93265 3.39087 6.99899C3.39087 7.06532 3.40602 7.13079 3.43517 7.19038C3.46431 7.24997 3.50669 7.30211 3.55905 7.34283L9.72233 12.1567C9.7948 12.2128 9.8987 12.1622 9.8987 12.0706V11.0137C9.8987 10.9467 9.86726 10.8825 9.8153 10.8415L4.89343 6.99967L9.8153 3.15651C9.86726 3.11549 9.8987 3.05123 9.8987 2.98424Z"
			fill="#2F3747"
		/>
	</svg>
);
